module.exports = __webpack_public_path__ + "img/icon_1_5.552de1e1.png";